import { SxProps, Theme } from '@mui/material/styles';
import { repurchasePillButtonSX } from '@/components/blocks/DpRepurchaseCoupon/styles/cta';

export const DPP_NAVY = '#0A2A8F';
const DPP_ORANGE = '#FF4900';
const DPP_ORANGE_HOVER = '#E04000';

const fullBleedSX: SxProps<Theme> = {
	width: '100vw',
	ml: 'calc(50% - 50vw)',
	boxSizing: 'border-box',
};

export const heroRootSX: SxProps<Theme> = {
	...fullBleedSX,
	mb: { xs: '40px', md: '64px' },
	py: { xs: '28px', md: '56px' },
	px: '16px',
	background: DPP_NAVY,
	color: '#FFFFFF',
};

export const heroInnerSX: SxProps<Theme> = {
	maxWidth: '1200px',
	mx: 'auto',
	display: 'flex',
	flexDirection: { xs: 'column', md: 'row' },
	alignItems: { xs: 'stretch', md: 'center' },
	justifyContent: 'space-between',
	gap: { xs: '24px', md: '48px' },
};

export const heroContentSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'flex-start',
	gap: { xs: '12px', md: '16px' },
	maxWidth: '640px',
};

export const heroEyebrowSX: SxProps<Theme> = {
	m: 0,
	fontSize: { xs: '11px', md: '12px' },
	fontWeight: 700,
	letterSpacing: '0.18em',
	textTransform: 'uppercase',
	color: 'rgba(255, 255, 255, 0.85)',
};

export const heroTitleSX: SxProps<Theme> = {
	m: 0,
	fontSize: { xs: '34px', md: '56px' },
	fontWeight: 800,
	lineHeight: 1,
	letterSpacing: '-0.01em',
	textTransform: 'uppercase',
	color: '#FFFFFF',
};

export const heroTextSX: SxProps<Theme> = {
	m: 0,
	maxWidth: '440px',
	fontSize: { xs: '14px', md: '15px' },
	lineHeight: 1.5,
	color: 'rgba(255, 255, 255, 0.9)',
};

export const heroTextStrongSX: SxProps<Theme> = {
	fontWeight: 700,
	color: '#FFFFFF',
};

export const heroCountdownLabelSX: SxProps<Theme> = {
	...heroEyebrowSX,
	mt: { xs: '4px', md: '8px' },
	fontSize: '11px',
};

export const heroCountdownSX: SxProps<Theme> = {
	display: 'flex',
	alignSelf: { xs: 'stretch', md: 'auto' },
	gap: { xs: '8px', md: '10px' },
	m: 0,
	p: 0,
	listStyle: 'none',
};

export const heroCountdownUnitSX: SxProps<Theme> = {
	flex: { xs: 1, md: '0 0 auto' },
	minWidth: { xs: 0, md: '88px' },
	py: { xs: '10px', md: '14px' },
	px: '6px',
	boxSizing: 'border-box',
	borderRadius: '12px',
	border: '1px solid rgba(255, 255, 255, 0.28)',
	background: 'rgba(255, 255, 255, 0.12)',
	color: '#FFFFFF',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: { xs: '2px', md: '4px' },
};

export const heroCountdownValueSX: SxProps<Theme> = {
	fontSize: { xs: '26px', md: '34px' },
	fontWeight: 800,
	lineHeight: 1.1,
	fontVariantNumeric: 'tabular-nums',
};

export const heroCountdownUnitLabelSX: SxProps<Theme> = {
	fontSize: { xs: '11px', md: '13px' },
	fontWeight: 500,
	letterSpacing: '0.04em',
	textTransform: 'uppercase',
	color: 'rgba(255, 255, 255, 0.85)',
};

export const heroButtonSX: SxProps<Theme> = {
	...repurchasePillButtonSX,
	mt: { xs: '4px', md: '8px' },
	alignSelf: { xs: 'stretch', md: 'auto' },
	gap: '8px',
	background: DPP_ORANGE,
	color: '#FFFFFF',
	boxShadow: '0 6px 16px rgba(0, 0, 0, 0.25)',
	transition: 'background-color 150ms ease',
	'&:hover, &:focus-visible': { background: DPP_ORANGE_HOVER, textDecoration: 'none' },
	'&:focus-visible': { outline: '2px solid #FFFFFF', outlineOffset: '3px' },
};

export const heroCardSX: SxProps<Theme> = {
	flexShrink: 0,
	width: { xs: '100%', md: '300px' },
	boxSizing: 'border-box',
	p: '20px',
	borderRadius: '12px',
	background: '#FFFFFF',
	outline: '2px dashed #FFFFFF',
	outlineOffset: '4px',
	color: '#2c2c2c',
	display: 'flex',
	flexDirection: 'column',
	gap: '6px',
};

export const heroCardLabelSX: SxProps<Theme> = {
	m: 0,
	fontSize: '10px',
	fontWeight: 700,
	letterSpacing: '0.16em',
	textTransform: 'uppercase',
	color: '#6b6b6b',
};

export const heroCardPercentageSX: SxProps<Theme> = {
	m: 0,
	display: 'flex',
	alignItems: 'baseline',
	gap: '8px',
	fontSize: { xs: '52px', md: '60px' },
	fontWeight: 800,
	lineHeight: 1,
	color: DPP_NAVY,
};

export const heroCardOffSX: SxProps<Theme> = {
	fontSize: { xs: '24px', md: '28px' },
	fontWeight: 800,
};

export const heroCardStatusSX: SxProps<Theme> = {
	m: 0,
	fontSize: '13px',
	color: '#2c2c2c',
};

export const heroCardStrongSX: SxProps<Theme> = {
	font: 'inherit',
	fontWeight: 700,
};

export const heroCardDividerSX: SxProps<Theme> = {
	my: '6px',
	borderTop: '1px solid #E5E5E5',
};

export const heroCardTermsSX: SxProps<Theme> = {
	m: 0,
	p: 0,
	listStyle: 'none',
	display: 'flex',
	flexDirection: 'column',
	gap: '4px',
};

export const heroCardTermItemSX: SxProps<Theme> = {
	position: 'relative',
	pl: '14px',
	fontSize: '12px',
	lineHeight: 1.45,
	color: '#4a4a4a',
	'&::before': {
		content: '""',
		position: 'absolute',
		left: 0,
		top: '0.5em',
		width: '6px',
		height: '6px',
		borderRadius: '50%',
		background: DPP_NAVY,
	},
};
